var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStageWhiteArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 3,
    viewBox: "0 0 24 3",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 1.44531L21.5 0.00193491L21.5 2.88869L24 1.44531ZM0 1.44531L2.18557e-08 1.69531L21.75 1.69531L21.75 1.44531L21.75 1.19531L-2.18557e-08 1.19531L0 1.44531Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStageWhiteArrow);
export default __webpack_public_path__ + "static/media/stage-white-arrow.34d6a73886b2f127b7bc8abec7cff356.svg";
export { ForwardRef as ReactComponent };